import Example from "../../components/SelectMultiple/SelectMultiple";
import Form, { GroupItem, SimpleItem } from "devextreme-react/form";
import React, { useCallback, useState, useEffect, useRef } from "react";
import * as DinamicQueries from "../../api/DinamicsQuery";
import { SelectBox } from "devextreme-react/select-box";
import { DateBox } from "devextreme-react/date-box";
import * as clientService from "../../api/clients";
import { fire, app } from "../../api/firebaseEnv";
import { Button } from "devextreme-react/button";
import { Toast } from "devextreme-react/toast";
import { useAuth } from "../../contexts/auth";
import settings from "../../api/enviroment";
import "./PreRegister.scss";
import Moment from "moment";
import axios from "axios";
import { Popup } from "devextreme-react/popup";
import { CheckBox } from "devextreme-react/check-box";
import DataGrid, {
  Column,
  FilterRow,
  Selection,
} from "devextreme-react/data-grid";

import { MultiSelect } from "react-multi-select-component";
import * as establecimientosService from "../../api/establishment";
export default function PreRegister() {
  const API_URL = settings.API_URL;
  const [nombre, setnombre] = useState();
  const { user } = useAuth();
  const [apellido, setapellido] = useState();
  const [cedula, setcedula] = useState();
  const [cliente, setcliente] = useState([]);
  const [clientes, setclientes] = useState([]);
  const [regiones, setregiones] = useState([]);
  const [nacionalidad, setnacionalidad] = useState("");
  const [perfil, setperfil] = useState("");
  const [fechaInicio, setfechaInicio] = useState();
  const [region, setregion] = useState();
  const [selected, setSelected] = useState([]);
  const [usuarios, setUsuarios] = useState([]);

  // Estados para plantillas de ruta
  const [showModalPlantillas, setShowModalPlantillas] = useState(false);
  const [plantillasRutas, setPlantillasRutas] = useState([]);
  const [plantillaSeleccionada, setPlantillaSeleccionada] = useState(null);
  const [establecimientosPlantilla, setEstablecimientosPlantilla] = useState(
    []
  );
  const [establecimientosSeleccionados, setEstablecimientosSeleccionados] =
    useState([]);

  const [toastConfig, setToastConfig] = React.useState(
    {
      isVisible: false,
      type: "success",
      message: "Guardado Exitosamente",
      displayTime: 2000,
    },
    []
  );

  const nacionalidades = [
    {
      Value: "V",
      Name: "V",
    },
    {
      Value: "E",
      Name: "E",
    },
  ];

  const perfiles = [
    {
      Value: "Supervisor",
      Name: "Supervisor",
    },
    {
      Value: "Promotor",
      Name: "Promotor",
    },
  ];

  const NewUser = {
    perfil: "",
    nombre: "",
    apellido: "",
    nacionalidad: "",
    cedula: 0,
    cliente: "",
    region: "",
    fechaInicio: new Date(),
    replace: "",
    orden_ruta: "",
    establecimientos: [],
  };

  const [NewUserPre, setNewUserPre] = useState(NewUser);
  const NewUserPreRef = useRef(NewUserPre);

  // Mantener la referencia actualizada cada vez que cambie el estado
  useEffect(() => {
    NewUserPreRef.current = NewUserPre;
    console.log("Estado actualizado en ref:", NewUserPre);
    console.log("Establecimientos en ref:", NewUserPre.establecimientos);
  }, [NewUserPre]);

  function OnSubmit(e) {
    // setNewUserPre(NewUser)

    // Usar la referencia para obtener el estado más reciente
    const estadoActual = NewUserPreRef.current;

    // Validar solo los campos obligatorios
    const camposObligatorios = {
      nombre: estadoActual.nombre,
      apellido: estadoActual.apellido,
      nacionalidad: estadoActual.nacionalidad,
      cedula: estadoActual.cedula,
      cliente: estadoActual.cliente,
      region: estadoActual.region,
      fechaInicio: estadoActual.fechaInicio,
      perfil: estadoActual.perfil,
    };

    for (const [campo, valor] of Object.entries(camposObligatorios)) {
      if (
        valor === undefined ||
        valor === "" ||
        valor === null ||
        (campo === "cedula" && valor === 0)
      ) {
        console.log(`Campo vacío detectado: ${campo} =`, valor);
        setToastConfig({
          ...toastConfig,
          type: "warning",
          message: `El campo ${campo} es obligatorio`,
          isVisible: true,
        });
        return;
      }
    }

    let menu_asig = [];
    perfil.forEach((cadaRol) => {
      if (estadoActual.perfil == cadaRol.nombre) {
        const data = cadaRol.menu.map((x) => {
          var mendef = { text: x.text };
          menu_asig.push(mendef);

          return x.text;
        });
      }
    });

    const userData = JSON.parse(localStorage.getItem("userData"));
    // Los establecimientos vienen directamente de la plantilla como objetos completos
    console.log("=== ONSUBMIT - ESTADO ACTUAL ===");
    console.log("NewUserPre completo (desde ref):", estadoActual);
    console.log(
      "NewUserPre.establecimientos (desde ref):",
      estadoActual.establecimientos
    );
    console.log("NewUserPre completo (desde state):", NewUserPre);
    console.log(
      "NewUserPre.establecimientos (desde state):",
      NewUserPre.establecimientos
    );
    const arrayEstablecimiento = estadoActual.establecimientos || [];

    console.log("Establecimientos a enviar:", arrayEstablecimiento);
    console.log("Cantidad de establecimientos:", arrayEstablecimiento.length);

    const dataFinal = {
      estatus: "Pre-Registrado",
      nombre: estadoActual.nombre,
      segundo_nombre: "",
      apellido: estadoActual.apellido,
      segundo_apellido: "",
      email: "",
      nacionalidad: estadoActual.nacionalidad,
      uid: "",
      direccion: "",
      cliente: [estadoActual.cliente],
      region: [estadoActual.region],
      cedula: estadoActual.cedula,
      telefono: "",
      fecha_insert: Moment().format("MMMM DD YYYY, h:mm"),
      user_insert: Moment().format("MMMM DD YYYY, h:mm"),
      perfil: estadoActual.perfil,
      // supervisor:[],
      establecimientos: arrayEstablecimiento,
      estatus: "Pre-Registrado",
      DatosBancarios: [
        {
          numeroCuenta: "",
          nombreBanco: "",
          tipoCuenta: "",
          estatus: "",
          numeroBanco: "",
        },
      ],
      menu: menu_asig, // respRoles.data[0].menu  revisar != undefined ? dataUser.menu.map((x)=>{return x.text}) : []
      paginaInicio: "/home",
      asignados: [
        {
          cedula: userData.cedula,
          nombre: userData.nombre + " " + userData.apellido,
          region: userData.region,
          uid: userData.uid,
        },
      ],
      superAdmin: false,
      replaceTo: estadoActual.replace,
      orden_ruta: estadoActual.orden_ruta || "",
    };

    console.log(dataFinal);

    axios
      .post(`${API_URL}Pre-Register`, dataFinal)
      .then((res) => {
        // if (res.data) {
        setNewUserPre(NewUser);
        setToastConfig({
          ...toastConfig,
          type: "success",
          message: "¡Guardado Exitosamente!",
          isVisible: true,
        });
        // }
      })
      .catch((error) => {
        setToastConfig({
          ...toastConfig,
          type: "warning",
          message: "No se guardo el usuarios",
          isVisible: true,
        });
      });
  }

  const renderSelectNacionalidad = (data) => {
    return (
      <SelectBox
        dataSource={nacionalidades}
        valueExpr="Value"
        displayExpr="Name"
        value={NewUserPre.nacionalidad}
        isRequired={true}
        onValueChanged={onValueChangedNacionalidad}
      />
    );
  };

  const onValueChangedNacionalidad = (event) => {
    setNewUserPre({ ...NewUserPre, nacionalidad: event.value });
  };

  const renderSelectPerfiles = (data) => {
    return (
      <SelectBox
        dataSource={perfil}
        valueExpr="nombre"
        displayExpr="nombre"
        value={NewUserPre.perfil}
        isRequired={true}
        onValueChanged={onValueChangedPerfiles}
      />
    );
  };

  const renderSelectUsuarios = (data) => {
    return (
      <SelectBox
        dataSource={usuarios}
        valueExpr="cedula"
        displayExpr="nombre"
        searchEnabled={true}
        value={NewUserPre.replace}
        onValueChanged={async (e) => {
          const cedulaSeleccionada = e.value || "";

          // Si se seleccionó un usuario, cargar sus establecimientos
          if (cedulaSeleccionada) {
            try {
              // Obtener datos del usuario por cédula
              const respUsuario = await DinamicQueries.getDataWithParameters(
                "getaByCedula",
                "usuarios/",
                { cedula: cedulaSeleccionada }
              );

              console.log("Respuesta usuario:", respUsuario);

              if (respUsuario.data && respUsuario.data.length > 0) {
                const usuario = respUsuario.data[0];
                const uid = usuario.id || usuario.key;

                console.log("Usuario encontrado:", usuario);
                console.log("UID:", uid);

                if (uid) {
                  // Obtener establecimientos del usuario
                  const respEstablecimientos =
                    await DinamicQueries.getDataWithParameters(
                      "getEstablecimientoNewCollection",
                      "usuarios/",
                      { uid: uid }
                    );

                  console.log(
                    "Respuesta establecimientos completa:",
                    respEstablecimientos
                  );
                  console.log(
                    "Respuesta establecimientos.data:",
                    respEstablecimientos.data
                  );

                  let establecimientosFormateados = [];
                  let ordenRuta = usuario.orden_ruta || "";

                  if (
                    respEstablecimientos.data &&
                    respEstablecimientos.data.data &&
                    respEstablecimientos.data.data.length > 0
                  ) {
                    const establecimientos = respEstablecimientos.data.data;

                    console.log(
                      "=== ESTABLECIMIENTOS DEL USUARIO REEMPLAZADO ==="
                    );
                    console.log(
                      "Cantidad de establecimientos raw:",
                      establecimientos.length
                    );
                    console.log("Establecimientos raw:", establecimientos);
                    console.log(
                      "Primer establecimiento ejemplo:",
                      establecimientos[0]
                    );

                    // Transformar los establecimientos al formato esperado
                    establecimientosFormateados = establecimientos.map(
                      (est, index) => {
                        // Convertir días si vienen como array
                        let dias = [];
                        if (Array.isArray(est.dias)) {
                          dias = est.dias;
                        } else {
                          // Convertir días booleanos a números si es necesario
                          if (est.lunes) dias.push(1);
                          if (est.martes) dias.push(2);
                          if (est.miercoles) dias.push(3);
                          if (est.jueves) dias.push(4);
                          if (est.viernes) dias.push(5);
                          if (est.sabado) dias.push(6);
                          if (est.domingo) dias.push(7);
                        }

                        const establecimientoFormateado = {
                          ID: est.ID || est.id,
                          dias: dias,
                          key: est.key || "",
                          nombre_establecimiento:
                            est.nombre_establecimiento || "",
                          nombre_region: est.nombre_region || "",
                          uid_region: est.uid_region || est.codigo_region || "",
                        };

                        if (index === 0) {
                          console.log(
                            "Ejemplo establecimiento formateado:",
                            establecimientoFormateado
                          );
                        }

                        return establecimientoFormateado;
                      }
                    );

                    console.log("=== ESTABLECIMIENTOS FORMATEADOS ===");
                    console.log(
                      "Cantidad de establecimientos formateados:",
                      establecimientosFormateados.length
                    );
                    console.log(
                      "Establecimientos formateados completos:",
                      establecimientosFormateados
                    );
                  } else {
                    console.log(
                      "⚠️ No se encontraron establecimientos para el usuario reemplazado"
                    );
                    console.log(
                      "Estructura de respuesta:",
                      JSON.stringify(respEstablecimientos.data, null, 2)
                    );
                  }

                  // Actualizar estado con todos los datos de una vez
                  console.log(
                    "=== ACTUALIZANDO ESTADO CON ESTABLECIMIENTOS ==="
                  );
                  console.log(
                    "Establecimientos que se van a guardar:",
                    establecimientosFormateados
                  );
                  console.log("Cantidad:", establecimientosFormateados.length);

                  setNewUserPre((prevState) => {
                    const nuevoEstado = {
                      ...prevState,
                      replace: cedulaSeleccionada,
                      establecimientos: establecimientosFormateados,
                      orden_ruta: ordenRuta,
                    };
                    console.log(
                      "Nuevo estado después de actualizar:",
                      nuevoEstado
                    );
                    console.log(
                      "Establecimientos en nuevo estado:",
                      nuevoEstado.establecimientos
                    );
                    return nuevoEstado;
                  });

                  if (establecimientosFormateados.length > 0) {
                    setToastConfig({
                      ...toastConfig,
                      type: "success",
                      message: `Se cargaron ${establecimientosFormateados.length} establecimientos del usuario seleccionado`,
                      isVisible: true,
                    });
                  } else {
                    setToastConfig({
                      ...toastConfig,
                      type: "info",
                      message:
                        "El usuario seleccionado no tiene establecimientos asignados",
                      isVisible: true,
                    });
                  }
                } else {
                  console.error("No se encontró UID del usuario");
                  setNewUserPre((prevState) => ({
                    ...prevState,
                    replace: cedulaSeleccionada,
                    establecimientos: [],
                    orden_ruta: "",
                  }));
                }
              } else {
                console.error("No se encontró usuario con esa cédula");
                setNewUserPre((prevState) => ({
                  ...prevState,
                  replace: cedulaSeleccionada,
                  establecimientos: [],
                  orden_ruta: "",
                }));
              }
            } catch (error) {
              console.error(
                "Error al cargar establecimientos del usuario:",
                error
              );
              setNewUserPre((prevState) => ({
                ...prevState,
                replace: cedulaSeleccionada,
                establecimientos: [],
                orden_ruta: "",
              }));
              setToastConfig({
                ...toastConfig,
                type: "warning",
                message:
                  "No se pudieron cargar los establecimientos del usuario",
                isVisible: true,
              });
            }
          } else {
            // Si se deseleccionó, limpiar establecimientos
            setNewUserPre((prevState) => ({
              ...prevState,
              replace: "",
              establecimientos: [],
              orden_ruta: "",
            }));
          }
        }}
      />
    );
  };

  const onValueChangedPerfiles = (event) => {
    setNewUserPre({ ...NewUserPre, perfil: event.value });
  };

  const renderSelectRegiones = (data) => {
    return (
      <SelectBox
        dataSource={regiones}
        // valueExpr="Value"
        // displayExpr="Name"
        isRequired={true}
        value={NewUserPre.region}
        onValueChanged={onValueChangedRegiones}
      />
    );
  };

  const onValueChangedRegiones = (event) => {
    NewUser.region = event.value;
    setregion(event.value);
    setNewUserPre({ ...NewUserPre, region: event.value });
  };

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    setclientes(userData.cliente);
    setregiones(userData.region);
    DinamicQueries.getData("getRoles", "roles/").then((respRoles) => {
      setperfil(respRoles.data);
    });
  }, []);

  const renderSelectCliente = (data) => {
    return (
      <SelectBox
        dataSource={clientes}
        // valueExpr="cod_cliente"
        // displayExpr="nombre_cliente"
        value={NewUserPre.cliente}
        isRequired={true}
        onValueChanged={handleSelectCliente}
      />
    );
  };

  const handleSelectCliente = (e) => {
    setNewUserPre({ ...NewUserPre, cliente: e.value, replace: "" });
    let Usuarios = [{ nombre: "", cedula: "" }];

    if (e.value && e.value.length > 0) {
      DinamicQueries.getDataWithParameters("getUserClients", "clientes/", {
        client: e.value,
      }).then((resp) => {
        Usuarios = [{ nombre: "", cedula: "" }, ...resp.data];
        // Filtrar duplicados por cédula
        Usuarios = Usuarios.filter(
          (usuario, index, self) =>
            index === self.findIndex((u) => u.cedula === usuario.cedula)
        );
        console.log(Usuarios);
        setUsuarios(Usuarios);
      });
    } else {
      setUsuarios([]);
    }
  };

  const onHiding = () => {
    setToastConfig({
      ...toastConfig,
      isVisible: false,
    });
  };

  const renderFecha = (data) => {
    return (
      <DateBox
        // className="SelectBoxDate mb-4"
        // placeholder="Fecha de reporte desde"
        // label="Desde"
        value={NewUserPre.fechaInicio}
        onValueChanged={(e) =>
          setNewUserPre({
            ...NewUserPre,
            fechaInicio: e.value,
          })
        }
        type="date"
      />
    );
  };

  // Funciones para manejar plantillas de ruta
  const abrirModalPlantillas = () => {
    if (!NewUserPre.cliente || !NewUserPre.region) {
      setToastConfig({
        ...toastConfig,
        type: "warning",
        message: "Debe seleccionar cliente y región primero",
        isVisible: true,
      });
      return;
    }
    DinamicQueries.getData("getrutasPlanilla", "rutasPlanilla/")
      .then((res) => {
        // Filtrar plantillas por región
        const plantillasFiltradas = res.data.filter((plantilla) =>
          NewUserPre.region.includes(plantilla.region)
        );
        setPlantillasRutas(plantillasFiltradas);
        setShowModalPlantillas(true);
      })
      .catch((error) => {
        setToastConfig({
          ...toastConfig,
          type: "error",
          message: "Error al cargar plantillas",
          isVisible: true,
        });
      });
  };

  const cerrarModalPlantillas = () => {
    setShowModalPlantillas(false);
    setPlantillaSeleccionada(null);
    setEstablecimientosPlantilla([]);
    setEstablecimientosSeleccionados([]);
  };

  const handlePlantillaSeleccionada = (e) => {
    setPlantillaSeleccionada(e.value);
    if (e.value) {
      DinamicQueries.getDataWithParameters(
        "getEstablecimientosByPlantilla",
        "rutasPlanilla/",
        { plantillaId: e.value }
      )
        .then((res) => {
          const establecimientosRaw = res.data.data || [];

          const diasMap = {
            1: "lunes",
            2: "martes",
            3: "miercoles",
            4: "jueves",
            5: "viernes",
            6: "sabado",
            7: "domingo",
          };

          const transformados = establecimientosRaw.map((est) => {
            const nuevo = { ...est };

            // Marcar días como true
            if (Array.isArray(est.dias)) {
              est.dias.forEach((n) => {
                const dia = diasMap[n];
                if (dia) nuevo[dia] = true;
              });
            }

            // Asegurar que todos los días estén presentes
            Object.values(diasMap).forEach((dia) => {
              if (!(dia in nuevo)) nuevo[dia] = false;
            });

            return nuevo;
          });
          console.log("establecimientos plantilla", transformados);
          setEstablecimientosPlantilla(transformados);
        })
        .catch(() => setEstablecimientosPlantilla([]));
    } else {
      setEstablecimientosPlantilla([]);
    }
  };

  const asignarPlantillaAUsuario = () => {
    if (!plantillaSeleccionada) {
      setToastConfig({
        ...toastConfig,
        type: "warning",
        message: "Debe seleccionar una plantilla",
        isVisible: true,
      });
      return;
    }
    if (establecimientosSeleccionados.length === 0) {
      setToastConfig({
        ...toastConfig,
        type: "warning",
        message: "Debe seleccionar al menos un establecimiento",
        isVisible: true,
      });
      return;
    }

    // Agregar los establecimientos seleccionados completos (con todos sus datos incluyendo dias)
    // Crear objetos limpios con solo los campos necesarios
    const establecimientosDePlantilla = establecimientosSeleccionados.map(
      (est) => {
        // Convertir días booleanos a array de números si es necesario
        let dias = [];
        if (Array.isArray(est.dias)) {
          dias = est.dias;
        } else {
          // Convertir días booleanos a números
          if (est.lunes) dias.push(1);
          if (est.martes) dias.push(2);
          if (est.miercoles) dias.push(3);
          if (est.jueves) dias.push(4);
          if (est.viernes) dias.push(5);
          if (est.sabado) dias.push(6);
          if (est.domingo) dias.push(7);
        }

        return {
          ID: est.ID || est.id,
          dias: dias,
          key: est.key || "",
          nombre_establecimiento: est.nombre_establecimiento || "",
          nombre_region: est.nombre_region || "",
          uid_region: est.uid_region || est.codigo_region || "",
        };
      }
    );

    // Obtener el orden_ruta de la plantilla seleccionada
    const plantillaEncontrada = plantillasRutas.find(
      (p) => p.id === plantillaSeleccionada
    );
    const ordenRuta = plantillaEncontrada?.orden_ruta || "";

    // Combinar con los establecimientos ya seleccionados si existen (todos vienen de plantillas)
    const establecimientosActuales = NewUserPre.establecimientos || [];
    const establecimientosCombinados = [...establecimientosActuales];

    // Agregar los nuevos de la plantilla, evitando duplicados por nombre
    establecimientosDePlantilla.forEach((nuevoEst) => {
      const existe = establecimientosCombinados.some(
        (e) =>
          e.nombre_establecimiento?.trim() ===
          nuevoEst.nombre_establecimiento?.trim()
      );
      if (!existe) {
        establecimientosCombinados.push(nuevoEst);
      }
    });

    setNewUserPre({
      ...NewUserPre,
      establecimientos: establecimientosCombinados,
      orden_ruta: ordenRuta,
    });

    setToastConfig({
      ...toastConfig,
      type: "success",
      message: "Establecimientos de la plantilla agregados correctamente",
      isVisible: true,
    });

    cerrarModalPlantillas();
  };

  const cellRendeRuta = (data) => {
    return (
      <div
        className="d-flex icons_grid"
        style={{ justifyContent: "center", display: "flex" }}
      >
        <CheckBox defaultValue={data.value} />
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className={"titlePreRegister mx-3 mt-4"}>
        <h5>Registrar usuario</h5>
        <p>
          Ingresar los datos del usuario para que pueda ser registrado en el
          sistema
        </p>
      </div>

      <div className={"FomularioPreRegister mx-3"}>
        <Form formData={NewUserPre}>
          <GroupItem colCount={2}>
            <SimpleItem dataField="nombre" isRequired={true} />
            <SimpleItem dataField="apellido" isRequired={true} />
            <SimpleItem
              dataField="nacionalidad"
              valueExpr="Value"
              displayExpr="Name"
              render={renderSelectNacionalidad}
              isRequired={true}
            />
            <SimpleItem dataField="cedula" isRequired={true} />
          </GroupItem>
          <GroupItem colCount={2}>
            <SimpleItem
              dataField="cliente"
              // valueExpr="cod_cliente"
              // displayExpr="nombre_cliente"
              render={renderSelectCliente}
              isRequired={true}
            />
            <SimpleItem
              dataField="fechaInicio"
              render={renderFecha}
              isRequired={true}
            />
            <SimpleItem
              dataField="region"
              // valueExpr="Value"
              // displayExpr="Name"
              render={renderSelectRegiones}
              isRequired={true}
            />

            <SimpleItem
              dataField="replace"
              label={{ text: "Sustituye a" }}
              render={renderSelectUsuarios}
            />

            <SimpleItem
              dataField="perfil"
              valueExpr="Value"
              displayExpr="Name"
              render={renderSelectPerfiles}
              isRequired={true}
            />
          </GroupItem>
        </Form>
        <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
          <div>
            <Button onClick={abrirModalPlantillas} className="btn btn-primary">
              Asignar plantilla de ruta
            </Button>
          </div>
          <div className="bntGuardar">
            <Button onClick={OnSubmit} className="btnGuardarPreRegister">
              Agregar
            </Button>
          </div>
        </div>
      </div>

      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        onHiding={onHiding}
        displayTime={toastConfig.displayTime}
      />

      <Popup
        visible={showModalPlantillas}
        onHiding={cerrarModalPlantillas}
        showTitle={true}
        title="Asignar plantilla de ruta"
        showCloseButton={true}
        fullScreen={true}
      >
        <div className="form-group d-flex align-items-end" style={{ gap: 16 }}>
          <div>
            <label>Selecciona una plantilla de ruta</label>
            <SelectBox
              dataSource={plantillasRutas}
              valueExpr="id"
              displayExpr="nombre_plantilla"
              value={plantillaSeleccionada}
              onValueChanged={handlePlantillaSeleccionada}
              searchEnabled={true}
              placeholder="Selecciona una plantilla"
              width={300}
              height={38}
            />
          </div>
          <div>
            <label>Orden de ruta</label>
            <div
              style={{
                padding: "8px 12px",
                border: "1px solid #ddd",
                borderRadius: "4px",
                minHeight: "32px",
                width: "100px",
                display: "flex",
                alignItems: "center",
                backgroundColor: "#f5f5f5",
              }}
            >
              {plantillaSeleccionada
                ? plantillasRutas.find((p) => p.id === plantillaSeleccionada)
                    ?.orden_ruta || "-"
                : "-"}
            </div>
          </div>
          <div
            className="d-flex"
            style={{ gap: 8, marginBottom: 0, alignItems: "flex-end" }}
          >
            <Button
              className="btn btn-primary"
              onClick={asignarPlantillaAUsuario}
              disabled={!plantillaSeleccionada}
            >
              Asignar
            </Button>
            <Button
              className="btn btn-secondary ml-2"
              onClick={cerrarModalPlantillas}
            >
              Cancelar
            </Button>
          </div>
        </div>
        {establecimientosPlantilla.length > 0 && (
          <div className="mt-3">
            <label>Establecimientos de la plantilla:</label>
            <DataGrid
              dataSource={establecimientosPlantilla}
              showBorders={true}
              style={{ height: "400px", width: "100%" }}
              keyExpr="ID"
              onSelectionChanged={(e) =>
                setEstablecimientosSeleccionados(e.selectedRowsData)
              }
            >
              <FilterRow visible={true} />
              <Selection mode="multiple" />
              <Column
                caption="ID"
                dataField="ID"
                dataType="string"
                width={100}
              />
              <Column
                caption="Nombre"
                dataField="nombre_establecimiento"
                dataType="string"
              />
              <Column
                caption="Región"
                dataField="nombre_region"
                dataType="string"
              />
              <Column
                caption="Lunes"
                dataField="lunes"
                allowSorting={false}
                alignment="center"
                cellRender={cellRendeRuta}
                allowFiltering={false}
              />
              <Column
                caption="Martes"
                dataField="martes"
                allowSorting={false}
                alignment="center"
                cellRender={cellRendeRuta}
                allowFiltering={false}
              />
              <Column
                caption="Miercoles"
                dataField="miercoles"
                allowSorting={false}
                alignment="center"
                cellRender={cellRendeRuta}
                allowFiltering={false}
              />
              <Column
                caption="Jueves"
                dataField="jueves"
                allowSorting={false}
                alignment="center"
                cellRender={cellRendeRuta}
                allowFiltering={false}
              />
              <Column
                caption="Viernes"
                dataField="viernes"
                allowSorting={false}
                alignment="center"
                cellRender={cellRendeRuta}
                allowFiltering={false}
              />
              <Column
                caption="Sabado"
                dataField="sabado"
                allowSorting={false}
                alignment="center"
                cellRender={cellRendeRuta}
                allowFiltering={false}
              />
              <Column
                caption="Domingo"
                dataField="domingo"
                allowSorting={false}
                alignment="center"
                cellRender={cellRendeRuta}
                allowFiltering={false}
              />
            </DataGrid>
          </div>
        )}
      </Popup>
    </React.Fragment>
  );
}
